import { clarityReady } from '@/helpers/promiseHelpers.ts'

export async function useClarity() {
  await clarityReady()

  return {
    set: (name: string, props?: Record<string, string | number | boolean | null | undefined>) => {
      window.clarity?.('event', name, props)
    },
    track: (name: string, props?: Record<string, string | number | boolean | null | undefined>) => {
      window.clarity?.('event', name, props)
    },
    identify: (id: string) => {
      window.clarity?.('identify', id)
    },
  }
}
